import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProviderWrapper } from "./components/context/AuthProviderWrapper";
import { BrowserRouter } from "react-router-dom";
import { NotificationWrapper } from "./components/context/NotificationWrapper";
import ErrorBoundary from "./components/context/ErrorBoundary";
import ErrorComponent from "./components/error/ErrorComponent";
import { DeclarationProviderWrapper } from "./components/context/DeclarationWrapper";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ErrorComponent />}>
      <BrowserRouter>
        <NotificationWrapper>
          <AuthProviderWrapper>
            <DeclarationProviderWrapper>
              <App />
            </DeclarationProviderWrapper>
          </AuthProviderWrapper>
        </NotificationWrapper>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
